import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../../../../modal/Modal';
import Button from '../../../../../../primitives/form/button/Button';
import WarningMessage from '../../../../../../WarningMessage/WarningMessage';

function DisablingFieldWarning(props) {
  const { showModal, closeModal } = props;

  return (
    <Modal showModal={showModal} modalSize="small">
      <ModalHeader>
        <h1 className="modal__small-title">Warning</h1>
        <h2 className="modal__large-title">Disabling Field</h2>
      </ModalHeader>
      <ModalBody>
        <WarningMessage
          message="Disabling will remove this field from view in the Library area. No new data can be submitted but all submitted data will be preserved."
          danger={false}
        />
      </ModalBody>
      <ModalFooter>
        <div className="form modal__footer--forms">
          <div className="cta__group cta__group--form">
            <Button
              name="OK"
              actionType="button"
              disable={false}
              buttonType="primary"
              handleClick={(e) => {
                closeModal();
              }}
            />
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default DisablingFieldWarning;
